export const ListServicesOptions: Array<{ value: RestaurantServiceTypes; label: string; }> = [
  { value: "pickup", label: "Pickup" },
  { value: "delivery", label: "Delivery" },
  { value: "dine_in", label: "Dine In" },
  { value: "table_booking", label: "Table Booking" },
];

export const ListServicesOptionsNoB: Array<{ value: RestaurantServiceTypes; label: string; }> = [
  { value: "pickup", label: "Pickup" },
  { value: "delivery", label: "Delivery" },
  { value: "dine_in", label: "Dine In" },
];

export const ListPaymentsOptions: Array<{ value: RestaurantPaymentTypes; label: string; }> = [
  { value: "cash", label: "Cash" },
  { value: "card", label: "Card" },
  { value: "stripe", label: "Stripe" },
  { value: "paypal", label: "PayPal" },
  { value: "cardconnect", label: "CardConnect" },
  { value: "paygate_payweb", label: "Paygate Payweb" },
  { value: "poli_pay", label: "POLi Pay" },
  { value: "ipay88", label: "IPay 88" },
  { value: "bambora_apac", label: "Bambora APAC" },
  { value: "pesapal", label: "Pesapal" },
];

export const ListOrderTimesOptions: Array<{ value: BusinessOrderingTimes; label: string; }> = [
  { value: "now", label: "Now" },
  { value: "later", label: "Later" },
];
